
import { Component, ElementRef, input, Input, InputSignal, Optional, Self, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule, MatTimepickerSelected } from '@angular/material/timepicker';
import { MatFormField, MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
@Component({
  selector: 'app-input',
  imports: [
    MatFormField,
    MatInputModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatDatepickerModule,
    MatTimepickerModule,
    MatIcon,
    MatAutocompleteModule
],
  templateUrl: './input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './input.component.scss'
})
export class InputComponent implements ControlValueAccessor {

  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() control: UntypedFormControl = new UntypedFormControl('');
  @Input() type: string = '';
  autocompleteList: InputSignal<any[]> = input<any[]>([]);
  autocompleteOptionLabel: InputSignal<string> = input<string>('');
  autocompleteDisplayFunction: InputSignal<((value: any) => string) | null> = input<((value: any) => string) | null>(
    (() => '')
  );

  value: string = '';
  dateValue: Date | undefined;

  //Controls for autocomplete
  isReadonly = true;
  inputElement = viewChild<ElementRef<HTMLInputElement>>('autoCompleteElement');
  autocompleteTrigger = viewChild(MatAutocompleteTrigger);

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  //ControlValueAccessor functions
  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value || '';
    this.control.setValue(value || '', { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  
  onDateChange(dateValue: Date | undefined) {
    this.dateValue = dateValue;
    this.onChange(dateValue);
    this.onTouched();
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.value;
    this.value = value;
    this.onChange(value);
    this.onTouched();
    setTimeout(() => {
      this.inputElement()?.nativeElement.blur();
      this.isReadonly = true;
    }, 0);
  }

  setDisabledState(isDisabled: boolean): void {
    if(isDisabled){
      this.control.disable({ emitEvent: false });
    }else{
      this.control.enable({ emitEvent: false });
    }
  }

  updateValue(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value = inputValue;
    this.onChange(inputValue);
    this.onTouched();
  }

  handleBlur() {
    this.isReadonly = true;
    this.onTouched();
  }

  handleFocus() {
    this.autocompleteTrigger()?.openPanel();
  }

  get errors() {
    return this.ngControl?.errors || null;
  }

  get invalid() {
    return !!this.errors && (this.ngControl?.touched || this.ngControl?.dirty);
  }

}
